import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
const AdminRoute: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const {
    user
  } = useUser();
  if (!user || !user.isAdmin) {
    return <Navigate to="/" replace data-id="element-276" />;
  }
  return <>{children}</>;
};
export default AdminRoute;